import * as api from "../api/index";

import {
  ADD_NEW_CLIENT,
  ALL_CLIENTS,
  UPDATE_CLIENT,
  DELETE_CLIENT,
  FETCH_CLIENTS_BY_USER,
  FETCH_CLIENT,
  START_LOADING,
  END_LOADING,
} from "./constants";

export const getClient = (id) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchClient(id);
    dispatch({ type: FETCH_CLIENT, payload: { client: data } });
  } catch (error) {
    console.log(error);
  }
};

export const getAllClients = () => async (dispatch) => {
 
  try {
    dispatch({ type: START_LOADING });
    const { data } = await api.fetchAllClients();

    //  console.log(data.email)
    dispatch({ type: ALL_CLIENTS, payload: data });
   // console.log("hello")
    dispatch({ type: END_LOADING });
   // console.log("world")
  } catch (error) {
    console.log(error);
  }
};

export const getClientsPage =
  (query, page, rowsPerPage) => async (dispatch) => {
    try {
      dispatch({ type: START_LOADING });
      const { data } = await api.fetchClientsPage({
        query,
        page,
        limit: rowsPerPage,
      });

      dispatch({
        type: ALL_CLIENTS,
        payload: {
          data: data.data || [],
          totalClients: data.totalItems ?? 0,
          currentPage: data.page ?? page,
          numberOfPages:
            rowsPerPage && data.totalItems != null
              ? Math.ceil(data.totalItems / rowsPerPage)
              : 0,
        },
      });
      dispatch({ type: END_LOADING });
    } catch (error) {
      console.log(error);
    }
  };
export const getClientsByUser = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: START_LOADING });
    const {
      data: { data },
    } = await api.fetchClientsByUser(searchQuery);

    dispatch({ type: FETCH_CLIENTS_BY_USER, payload: data });
    dispatch({ type: END_LOADING });
  } catch (error) {
    console.log(error.response);
  }
};

export const createClient = (client, openSnackbar) => async (dispatch) => {
  try {
    const { data } = await api.addClient(client);
    dispatch({ type: ADD_NEW_CLIENT, payload: data });
    openSnackbar("Customer added successfully");
    return data;
  } catch (error) {
    console.log(error);
    const message =
      error?.response?.data?.message || "Failed to add customer";
    openSnackbar(message);
    throw error;
  }
};

export const updateClient = (id, client, openSnackbar) => async (dispatch) => {
  const { data } = await api.updateClient(id, client);
  dispatch({ type: UPDATE_CLIENT, payload: data });
  openSnackbar("Customer updated successfully");
  try {
  } catch (error) {
    console.log(error);
  }
};

export const deleteClient = (id, openSnackbar) => async (dispatch) => {
  try {
    await api.deleteClient(id);

    dispatch({ type: DELETE_CLIENT, payload: id });
    openSnackbar("Customer deleted successfully");
  } catch (error) {
    console.log(error);
  }
};
